import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';

import { useOmBoligenFormContext } from '../utils';
import { PlasseringAvEnhetIByggHorisontalt } from '../../../../../../components/registering/utils/registerEnums';

export const HorisontalPlasseringLeilighetRadio = () => {
  const { register, formState } = useOmBoligenFormContext();
  const { t } = useTranslation('', {
    keyPrefix: 'register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggHorisontalt'
  });

  const horisontalPlasseringRegister = register('bygginfo.horizontalPlacement', {
    required: t('error')
  });

  const error = formState.errors.bygginfo?.horizontalPlacement?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>{t('label')}</Fieldset.Legend>

      <Radio
        {...horisontalPlasseringRegister}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.Endeleilighet}`)}
        value={PlasseringAvEnhetIByggHorisontalt.Endeleilighet}
        aria-invalid={!!error}
      />
      <Radio
        {...horisontalPlasseringRegister}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.FrittstaendeLeilighet}`)}
        value={PlasseringAvEnhetIByggHorisontalt.FrittstaendeLeilighet}
        aria-invalid={!!error}
      />
      <Radio
        {...horisontalPlasseringRegister}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.Hjorneleilighet}`)}
        value={PlasseringAvEnhetIByggHorisontalt.Hjorneleilighet}
        aria-invalid={!!error}
      />
      <Radio
        {...horisontalPlasseringRegister}
        label={t(`option.${PlasseringAvEnhetIByggHorisontalt.Midtleilighet}`)}
        value={PlasseringAvEnhetIByggHorisontalt.Midtleilighet}
        aria-invalid={!!error}
      />

      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
